import { render } from "./UserDataPage.vue?vue&type=template&id=b8363b26"
import script from "./UserDataPage.vue?vue&type=script&lang=js"
export * from "./UserDataPage.vue?vue&type=script&lang=js"

import "./UserDataPage.vue?vue&type=style&index=0&id=b8363b26&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__